export const Avatar = () => (
  <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.0602 3.39453C10.8602 3.39453 3.39355 10.8612 3.39355 20.0612C3.39355 29.2612 10.8602 36.7279 20.0602 36.7279C29.2602 36.7279 36.7269 29.2612 36.7269 20.0612C36.7269 10.8612 29.2602 3.39453 20.0602 3.39453ZM20.0602 8.39453C22.8269 8.39453 25.0602 10.6279 25.0602 13.3945C25.0602 16.1612 22.8269 18.3945 20.0602 18.3945C17.2936 18.3945 15.0602 16.1612 15.0602 13.3945C15.0602 10.6279 17.2936 8.39453 20.0602 8.39453ZM20.0602 32.0612C15.8936 32.0612 12.2102 29.9279 10.0602 26.6945C10.1102 23.3779 16.7269 21.5612 20.0602 21.5612C23.3769 21.5612 30.0102 23.3779 30.0602 26.6945C27.9102 29.9279 24.2269 32.0612 20.0602 32.0612Z"
      fill="#BBD0FB"
    />
  </svg>
);
